import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/act_type_2.png'
import _imports_1 from '@/assets/images/act_type_1.png'


const _withScopeId = n => (_pushScopeId("data-v-253ac7cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "center" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_6 = { class: "subTitle van-ellipsis" }
const _hoisted_7 = { class: "bottom" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('im.activity'),
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
    }, null, 8 /* PROPS */, ["title"]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: $setup.loading,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.loading) = $event)),
      onRefresh: $setup.onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: $setup.loading,
          "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => (($setup.loading) = $event)),
          finished: $setup.finished,
          "finished-text": $setup.t('me.mygdl'),
          onLoad: $setup.onLoad
        }, {
          default: _withCtx(() => [
            ($setup.listData.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.listData, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "itembox",
                    onClick: ($event: any) => ($setup.toDetail(item))
                  }, [
                    _createVNode(_component_van_image, {
                      radius: "10",
                      "lazy-load": "",
                      fit: "cover",
                      width: "105",
                      height: "105",
                      src: item.cover
                    }, null, 8 /* PROPS */, ["src"]),
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_3, [
                          (item.type == 1 && !$setup.isTh)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                            : _createCommentVNode("v-if", true),
                          (item.type == 2 && !$setup.isTh)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("span", null, _toDisplayString(item.title), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(item.info), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            src: $setup.commentIcon,
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_8),
                          _createElementVNode("span", null, _toDisplayString(item.comment_num), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            src: $setup.zanIcon,
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_9),
                          _createElementVNode("span", null, _toDisplayString(item.zan), 1 /* TEXT */)
                        ])
                      ])
                    ])
                  ], 8 /* PROPS */, _hoisted_1))
                }), 256 /* UNKEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["loading", "finished", "finished-text"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ], 64 /* STABLE_FRAGMENT */))
}